import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react'

import { useSesion } from './auth'
import { escribirVerComo, leerVerComo, type VistaCliente } from './lib/ver-como'

interface VerComoCtx {
    vista: VistaCliente | null
    comoCliente: boolean
    entrar: (v: VistaCliente) => void
    salir: () => void
}

const Ctx = createContext<VerComoCtx | null>(null)

export function VerComoProvider({ children }: { children: ReactNode }) {
    const [vista, setVista] = useState<VistaCliente | null>(leerVerComo)

    const entrar = useCallback((v: VistaCliente) => {
        escribirVerComo(v)
        setVista(v)
    }, [])

    const salir = useCallback(() => {
        escribirVerComo(null)
        setVista(null)
    }, [])

    const value = useMemo(
        () => ({ vista, comoCliente: vista !== null, entrar, salir }),
        [vista, entrar, salir],
    )

    return <Ctx.Provider value={value}>{children}</Ctx.Provider>
}

export function useVerComo(): VerComoCtx {
    const ctx = useContext(Ctx)
    if (!ctx) throw new Error('useVerComo fuera de VerComoProvider')
    return ctx
}

/** Admin de verdad, no uno que está mirando como el dueño. */
export function useEsAdminUi(): boolean {
    const { data: sesion } = useSesion()
    const { comoCliente } = useVerComo()
    return sesion?.role === 'admin' && !comoCliente
}
